export var props = {
  giftList: {
    default: () => [],
    type: Array
  }
};